<template>
  <section class="content checkout-content d-flex justify-content-center pt-0 wp_MarginBottomAllPage">
    <div class="clientauth-wrapper mt-5">
					<div class="col-12">
						<div class="form-signin">
							<h1 class="h3 mb-3 font-weight-normal text-center"
											id="sign-in-form-head"
											data-test="BankSignInFormHeading">
								Bank Customer Signup
							</h1>
							<bank-login-form/>
							<hr>
							<p class="newuser"
										data-test="BankSignInFormNewCustomer"
										id="BankSignInFormNewCustomer">New Customer?
								<a href=""
											@click.prevent="$router.push('/signup')"
											data-test="BankSignInFormRegisterLink"
											id="BankSignInFormRegisterLink"
								>
									Register
								</a>
							</p>
							<p class="newuser">Already a Customer?
								<a href=""
											@click.prevent="$router.push('/login')"
											data-test="BankLoginFormRegisterLink"
								>
									Login
								</a>
							</p>
						</div>
					</div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import BankLoginForm from '@/components/pages/login/forms/BankLoginForm'
import { orderApi } from '@/services/ApiServices/orderApi'

export default {
	beforeMount () {
		if (this.isAuthenticated) {
			this.$router.push('/')
		}
	},
	data () {
		return {
			product_id: '',
			order_status: ''
		}
	},
	components: {
		BankLoginForm
	},
	computed: {
		...mapGetters('productselected', ['getSelectedProduct']),
		...mapGetters('order', ['getTotalOrderData']),
		...mapGetters('user', ['isAuthenticated'])
	},
	methods: {
		redirectToCheckOutPage () {
			for (let i = 0; i < this.getSelectedProduct.length; i += 1) {
				this.product_id = this.getSelectedProduct[i].product_id
			}
			if (this.$route.query.next_to === 'current') {

			} else if (this.$route.query.next_to === 'wishList') {
				this.$router.push({
					path: '/user/wish-list',
					query: {
						product_id: this.$route.query.product_id,
						display_text: 'My Wishlist'
					}
				})
			} else if (this.$route.query.next_to === 'checkOut') {
				this.$router.push({
					name: 'CheckoutPage'
				})
			} else if (this.$route.query.next_to === 'previous') {
				this.$router.go(-1)
			} else if (this.$route.query.next_to === 'orders') {
				this.$router.push({
					path: '/user/orders'
				})
			} else if (this.$route.query.next_to === 'user') {
				this.$router.push({
					path: '/user/account'
				})
			} else if (this.$route.query.next_to === 'GiftCard') {
				this.$router.push({
					path: '/user/giftCards',
					query: {
						display_text: 'Gift Cards'
					}
				})
			} else if (this.$route.query.next_to === 'cart') {
				this.$router.push({
					path: '/cart',
					query: {
						display_text: 'My Cart'
					}
				})
			} else if (this.$route.query.next_to === 'home') {
				this.$router.push({
					path: '/'
				})
			} else if (this.$route.query.next_to === 'orderRating') {
				orderApi.getOrderStatus(this.product_id)
					.then((res) => {
						if (res.data.delivered_status && res.data.is_ordered) {
							this.$router.push({
								path: '/user/orders/orderRating',
								query: {
									orderProductId: this.product_id,
									orderVendorId: ''
								}
							})
						} else if (res.data.delivered_status || res.data.is_ordered) {
							this.$router.push('/')
							this.$toasted.show('Only ordered, product haven\'t delivered yet')
						} else {
							this.$router.push('/')
							this.$toasted.show('Sorry! You are not allowed to review this product since you haven\'t bought it')
						}
					})
					.catch((e) => {

					})
			} else {
				this.$router.push('/')
			}
		}
	}
}
</script>
